import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import ServicesPage from "./pages/ServicesPage";
import AdvancedStrategiesPage from "./pages/AdvancedStrategiesPage";
import ForAdvisorsPage from "./pages/ForAdvisorsPage";
import ResultsPage from "./pages/ResultsPage";
import AboutPage from "./pages/AboutPage";
import StrategyComparisonGatePage from "./pages/StrategyComparisonGatePage";
import WhitePaperGatePage from "./pages/WhitePaperGatePage";
import AnalyticsAdmin from "./pages/AnalyticsAdmin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route
            path="/advanced-conversion-strategies"
            element={<AdvancedStrategiesPage />}
          />
          <Route path="/for-advisors" element={<ForAdvisorsPage />} />
          <Route path="/results" element={<ResultsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route
            path="/strategy-comparison-gate"
            element={<StrategyComparisonGatePage />}
          />
          <Route path="/white-paper-gate" element={<WhitePaperGatePage />} />
          <Route path="/admin/analytics" element={<AnalyticsAdmin />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
